__webpack_require__.p = "https://stdatavisualprod.blob.core.windows.net/$web/projects/24/08/taliban-women/prs/";